import { Box } from '@rbilabs/universal-components';

export const MapContainer = Box.withConfig({
  height: 'full',
  paddingTop: '$8',
});
